<template>
  <div
    class="slide"
    :class="[{ active, even, custom, twoSides }, customClass]"
    key="even"
  >
    <template v-if="twoSides">
      <div
        v-if="category && !isMobileView"
        class="category-container"
        @click="openCategory(category)"
      >
        <div class="category">
          <span>{{ category.name }}</span>
        </div>
      </div>
      <div class="left-side" :class="{ 'image-opened': even && imageOpened }">
        <div class="side-inner">
          <template v-if="!custom">
            <template v-if="even">
              <div class="slide-image">
                <div
                  class="image-wrapper"
                  @click="toggleLightbox"
                  style="transform: rotate(4deg)"
                >
                  <img :src="story.image" class="image-back" alt ref="image" />
                  <img :src="story.image" alt />
                </div>
              </div>
            </template>
            <div v-else class="slide-content">
              <div
                class="sound"
                :class="{ playing: soundPlaying }"
                @click.prevent="playStopSound"
              >
                <a href="#" class="btn">{{
                  `${soundPlaying ? "Остановить" : "Прослушать"}`
                }}</a>
              </div>
              <div
                class="slide-text"
                @scroll="handleTextScroll"
                :class="{ 'transparent-bottom': tranparentText }"
                ref="slideText"
              >
                <h2 class="slide-title">{{ story.title }}</h2>
                <p class="description">
                  <span>Автор:</span>
                  {{ story.author }}
                </p>
                <p class="description">
                  <span v-if="story.work">Предприятие:</span>
                  {{ story.work }}
                </p>
                <div class="text" v-html="story.content"></div>
              </div>
            </div>
          </template>
          <template v-else>
            <slot name="left-side"></slot>
          </template>
        </div>
      </div>
      <div class="right-side" :class="{ 'image-opened': !even && imageOpened }">
        <div class="side-inner">
          <template v-if="!custom">
            <div
              v-if="category && isMobileView"
              class="category-container"
              @click="openCategory(category)"
            >
              <div class="category">
                <span>{{ category.name }}</span>
              </div>
            </div>
            <div v-if="even" class="slide-content">
              <div
                class="sound"
                :class="{ playing: soundPlaying }"
                @click.prevent="playStopSound"
              >
                <a href="#" class="btn">{{ soundButtonText }}</a>
              </div>
              <div
                class="slide-text"
                @scroll="handleTextScroll"
                :class="{ 'transparent-bottom': tranparentText }"
                ref="slideText"
              >
                <h2 class="slide-title">{{ story.title }}</h2>
                <p class="description">
                  <span>Автор:</span>
                  {{ story.author }}
                </p>
                <p class="description">
                  <span v-if="story.work">Предприятие:</span>
                  {{ story.work }}
                </p>
                <div class="text" v-html="story.content"></div>
              </div>
            </div>
            <template v-else>
              <div class="slide-image">
                <div
                  class="image-wrapper"
                  @click="toggleLightbox"
                  style="transform: rotate(-4deg)"
                >
                  <img :src="story.image" class="image-back" alt />
                  <img :src="story.image" alt />
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <slot name="right-side"></slot>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: {
    even: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      dafault: false,
    },
    category: {
      type: Object,
      default: null,
    },
    custom: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    twoSides: {
      type: Boolean,
      default: true,
    },
    soundRun: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sound: null,
      imageOpened: false,
      tranparentText: true,
      clipStyle: null
    };
  },
  methods: {
    ...mapActions([
      "openCategory",
      "toggleLightbox",
      "toggleSound",
      "changeStory",
      "clearAutoplayTimeout",
      "startWithSound"
    ]),
    playStopSound() {
      if (this.sound.paused) {
        this.sound.play();
        this.toggleSound(true);
      } else {
        this.sound.pause();
        this.toggleSound(false);
      }
    },
    handleScroll() {
      if (!this.sound.paused) {
        if (event.deltaY > 0) {
          if (this.sound.volume >= 0.05) {
            this.sound.volume -= 0.05;
          } else {
            this.sound.volume = 0;
          }
        } else if (event.deltaY < 0) {
          if (this.sound.volume <= 0.95) {
            this.sound.volume += 0.05;
          } else {
            this.sound.volume = 1;
          }
        }
      }
    },
    handleTextScroll() {
      if (
        this.$refs.slideText.scrollTop + this.$refs.slideText.offsetHeight >=
        this.$refs.slideText.scrollHeight
      ) {
        this.tranparentText = false;
      } else {
        this.tranparentText = true;
      }
    },
  },
  computed: {
    ...mapState([
      "soundPlaying",
      "autoplayDelay",
      "currentStoryIndex",
      "autoplayCurrentProgress",
      "autoplay",
      "autoplayTimeout",
      "windowHeight",
      "headerHeight",
      "strings",
      "stories",
      "soundStart"
    ]),
    ...mapGetters({ story: "currentStory", isMobileView: "isMobileView" }),
    soundButtonText() {
      return this.isMobileView
        ? ""
        : this.soundPlaying
        ? this.strings.soundPauseText
        : this.strings.soundPlayText;
    },
  },
  mounted() {
    if (this.soundRun && this.soundStart) {
      this.startWithSound(false)
      setTimeout(() => {
        this.playStopSound();
      }, 1500);
    }
    if (this.story) {
      this.sound = new Audio(this.story.sound);
      if (this.soundPlaying) {
        setTimeout(() => {
          this.sound.play();
        }, 1500);
      }
      window.addEventListener("wheel", this.handleScroll);

      if (this.autoplay) {
        this.$store.commit(
          "setAutoplayTimeout",
          setTimeout(() => {
            if (this.autoplayCurrentProgress === 0) {
              this.$store.commit(
                "setAutoplayCurrentProgress",
                this.autoplayCurrentProgress + 100
              );
              this.$store.commit(
                "setAutoplayTimeout",
                setTimeout(() => {
                  this.changeStory(this.currentStoryIndex + 1);
                }, this.story.duration)
              );
            }
          }, 1500)
        );
      }

      this.handleTextScroll();
      window.addEventListener("resize", this.handleTextScroll);
    }
  },
  destroyed() {
    if (this.sound) {
      this.sound.pause();
      window.removeEventListener("wheel", this.handleScroll);
    }
    if (this.autoplay) {
      this.$store.commit("setAutoplayCurrentProgress", 0);
      this.clearAutoplayTimeout();
    }
    window.removeEventListener("resize", this.handleTextScroll);
  },
};
</script>

<style lang="scss">
.slide {
  height: 100%;
  .slider-navigation {
    z-index: 35;
  }
}
.slide.twoSides {
  display: flex;
  position: absolute;
  width: 120vw;
  margin-left: -10vw;
  background: linear-gradient(222.35deg, #1e82f5 0%, #002277 98.59%);
  z-index: 10;
  &.active {
    z-index: 20;
  }
  .slide-title {
    margin-top: 0;
  }
  .left-side,
  .right-side {
    height: 100%;
    transform: skewX(-12deg) translateZ(0);
    overflow: hidden;
    &.image-opened {
      transition: 0.4s;
      .slide-image {
        &:before {
          content: none;
        }
      }
    }
  }
  .side-inner {
    height: 100%;
    transform: skewX(12deg);
  }
  .left-side {
    width: 47.5%;
    background: linear-gradient(222.35deg, #1e82f5 0%, #002277 98.59%);
    .side-inner {
      position: relative;
      transform-origin: top;
      &:after {
        content: "";
        position: absolute;
        height: 100%;
        bottom: 0;
        left: 5vw;
        width: 74%;
        background-image: url("~@/assets/img/fotoistoria.svg");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;
        pointer-events: none;
        z-index: -2;
      }
    }
  }
  &.first-slide {
    .left-side {
      width: 65%;
      .side-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        .content {
          width: 45vw;
          color: #fff;
          font-size: 36px;
          line-height: 42px;
          padding-bottom: 40px;
          .btn {
            margin-top: 40px;
          }
        }
        &:after {
          content: "";
          position: absolute;
          width: 100%;
          max-height: 120px;
          bottom: 0;
          left: 6vw;
          background-image: url("~@/assets/img/rubrics.svg");
          background-position: left;
        }
      }
    }
    .right-side {
      width: 35%;
      background-color: #f8f8f8;
      box-shadow: inset 0 -80px 50px 5px rgba(0, 0, 0, 0.2);
      .side-inner {
        display: flex;
        justify-content: center;
      }
    }
  }
  .right-side {
    width: 52.5%;
    .side-inner {
      &:after {
        content: none;
      }
    }
  }
  .slide-image {
    position: relative;
    height: 100%;
    margin-left: -10vw;
    box-shadow: inset 0 -100px 50px 20px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("~@/assets/img/mainbg.jpg") no-repeat center;
    background-size: cover;
    .image-wrapper {
      position: relative;
      width: 65%;
      height: 65%;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: rotate(4deg);
      &:hover {
        cursor: pointer;
        &:before {
          opacity: 1;
        }
      }
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/img/zoom-in.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 60px;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 99;
      }
      img {
        box-shadow: 2px 5px 14px 10px rgba(75, 91, 111, 0.1);
        border: 30px solid #fff;
        max-height: 100%;
        position: relative;
        &.image-back {
          position: absolute;
          transform: rotate(4deg);
        }
      }
    }
  }
  .category-container {
    position: absolute;
    top: 50px;
    right: 0;
    overflow: hidden;
    margin-right: 10vw;
    z-index: 99;
    transition: 0.3s;
    .category {
      color: #fff;
      font-weight: bold;
      padding: 10px 20px;
      background-color: #0055bb;
      margin: 0 -10px 0 10px;
      transform: skew(-20deg);
      span {
        display: block;
        transform: skew(20deg);
      }
      &:hover {
        cursor: pointer;
        background-color: #01489e;
      }
    }
  }
  .slide-content {
    padding: 50px 10vw 0 10vw;
    color: #fff;
    position: relative;
    .sound {
      text-align: right;
      margin-bottom: 50px;
      .btn {
        position: relative;
        padding: 5px 30px;
        padding-left: 80px;
        &:after {
          content: "";
          position: absolute;
          top: 50%;
          left: 35px;
          width: 20px;
          height: 20px;
          transform: translateY(-50%);
          background-image: url("~@/assets/img/play.svg");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }
      }
      &.playing {
        .btn {
          &:after {
            background-image: url("~@/assets/img/pause.svg");
            width: 15px;
          }
        }
      }
    }
    .description {
      font-weight: 600;
      margin: 0;
      span {
        font-weight: 300;
      }
    }
    .slide-text {
      max-height: calc(100vh - 360px);
      overflow-y: auto;
      padding-right: 40px;
      &.transparent-bottom {
        mask-image: linear-gradient(to bottom, black 80%, transparent 95%);
      }
      .text {
        margin-top: 20px;
      }
    }
  }
  &.even {
    .category-container {
      left: 0;
      right: auto;
      margin-left: 10vw;
      .category {
        margin: 0 10px 0 -10px;
      }
    }
    .left-side {
      width: 47.5%;
      .side-inner {
        &:after {
          content: none;
        }
      }
      &.image-opened {
        width: 120vw;
        position: fixed;
        z-index: 999;
        margin-left: -1vw;
        .slide-image {
          z-index: 999;
        }
      }
      .slide-image {
        margin-left: 0;
        &:before {
          background-position: 40% center;
        }
      }
    }
    .right-side {
      width: 52.5%;
      background: linear-gradient(222.35deg, #1e82f5 0%, #002277 98.59%);
      .side-inner {
        &:after {
          content: "";
          position: absolute;
          width: 90%;
          height: 100%;
          bottom: 0;
          left: -4vw;
          background-image: url("~@/assets/img/fotoistoria.svg");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: bottom;
          pointer-events: none;
          z-index: -1;
        }
      }
    }
    .slide-content {
      padding: 50px 13vw 0 8vw;
    }
  }
}
.slide {
  .main-page {
    .orbits {
      .ellipse {
        top: 50%;
      }
    }
    .text-content {
      max-width: 40vw;
    }
    margin-top: 0;
    .ghost-text {
      width: 100%;
      text-align: center;
    }
    p {
      font-size: 1.5rem;
      line-height: 2rem;
      font-weight: bold;
    }
    h2 {
      font-weight: bold;
    }
  }
}
#portrait .slide {
  width: 100%;
  margin: 0;
  flex-direction: column;
  display: block;
  position: relative;
  background: none;
  .left-side,
  .right-side {
    width: 100%;
    transform: skew(0);
    overflow: visible;
    .side-inner {
      transform: skew(0);
      &:after {
        content: none;
      }
      .slide-image {
        box-shadow: none;
        background: none;
        .image-wrapper {
          width: 85%;
          height: 65%;
          margin-top: 20px;
          .image-back {
            transform: rotate(5deg);
          }
        }
      }
    }
  }
  .left-side {
    height: 60vh;
    background: url("~@/assets/img/mainbg.jpg") no-repeat center;
  }
  .right-side {
    height: auto;
    min-height: 40vh;
    .side-inner {
      .category-container {
        bottom: 102%;
        top: auto;
        left: 0;
        margin: 0;
        max-width: 230px;
      }
      .slide-content {
        padding: 10px 30px 20px;
        .sound {
          position: absolute;
          bottom: 102%;
          top: auto;
          line-height: 10px;
          right: 15px;
          margin: 0;
          a {
            height: 32px;
            min-width: 0;
            padding-left: 32px;
            &:after {
              left: 22px;
            }
          }
        }
        .slide-text {
          max-height: none;
          overflow: auto;
        }
      }
    }
    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      transform: skew(0, -8deg);
      z-index: -30;
      transform-origin: left;
      background: linear-gradient(222.35deg, #1e82f5 0%, #002277 98.59%);
    }
  }
}
#portrait .slide.first-slide {
  .left-side {
    height: 35vh;
    background-image: none;
    background-color: #f8f8f8;
    .side-inner {
      .categories {
        margin-top: 120px;
      }
    }
  }
  .right-side {
    min-height: 65vh;
    background: linear-gradient(222.35deg, #1e82f5 0%, #002277 98.59%);
    padding: 40px 50px;
    .side-inner {
      .content {
        color: #fff;
        font-size: 24px;
        line-height: 30px;
        text-align: center;
        p {
          text-align: left;
        }
        .btn {
          margin-top: 20px;
        }
      }
    }
    &:before {
      content: none;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .slide.twoSides {
    &.first-slide {
      .left-side {
        .side-inner {
          .content {
            font-size: 26px;
            line-height: 30px;
            .btn {
              margin-top: 15px;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .slide.twoSides {
    .slide-image {
      .image-wrapper {
        img {
          border: 28px solid #fff;
          &.image-back {
            transform: rotate(6deg);
          }
        }
      }
    }
    .slide-content {
      .slide-text {
        padding-right: 20px;
      }
    }
    &.first-slide {
      .left-side {
        .side-inner {
          .content {
            font-size: inherit;
            line-height: inherit;
            padding-bottom: 50px;
            .btn {
              margin-top: 15px;
            }
          }
          &:after {
            width: 70%;
          }
        }
      }
      .right-side {
        width: 35%;
        background-color: #f8f8f8;
        .side-inner {
          display: flex;
          justify-content: center;
        }
      }
    }
  }
  .slide {
    .main-page {
      .text-content {
        max-width: 70vw;
        margin-top: -50px;
      }
      p {
        font-size: 1.2rem;
        line-height: 1.8rem;
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .slide.twoSides {
    .slide-image {
      .image-wrapper {
        width: 55%;
        height: 55%;
        img {
          border: 18px solid #fff;
        }
      }
    }
    .slide-content {
      .sound {
        margin-bottom: 30px;
      }
      .slide-text {
        max-height: calc(100vh - 300px);
      }
    }
    &.first-slide {
      .left-side {
        .side-inner {
          &:after {
            bottom: -3%;
          }
        }
      }
    }
    &.even {
      .slide-content {
        padding: 50px 14vw 0 8vw;
      }
    }
  }
  .slide {
    .main-page {
      p {
        font-size: 1rem;
        line-height: 1.2rem;
      }
      h2 {
        font-size: 24px;
        line-height: 30px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .slide.twoSides {
    .slide-image {
      .image-wrapper {
        img {
          border: 14px solid #fff;
        }
      }
    }
    .category {
      top: 30px;
      padding: 6px 20px;
    }
    .slide-content {
      padding: 30px 10vw 0 8vw;
      .sound {
        margin-bottom: 20px;
      }
      .slide-text {
        max-height: calc(100vh - 250px);
      }
    }
    &.even {
      .slide-content {
        padding: 30px 15vw 0 7vw;
      }
    }
  }
}
@media only screen and (max-width: 480px) {
  #portrait .slide {
    .right-side {
      .side-inner {
        .slide-image {
          .image-wrapper {
            width: 85%;
            height: 70%;
            margin-top: 0;
          }
        }
      }
      &:before {
        transform: skew(0, -14deg);
      }
    }
    &.first-slide {
      .left-side {
        .side-inner {
          .categories {
            margin-top: 60px;
          }
        }
      }
      .right-side {
        padding: 20px;
        .side-inner {
          .content {
            color: #fff;
            font-size: 18px;
            line-height: 24px;
            .btn {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>